import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import './estilos.css';
import { App } from './App.tsx';
import { ProvedorAuth } from './contexto/auth.tsx';

// `retry: false` de propósito: quando o fechamento falha por regra faltando ou
// vínculo errado, repetir três vezes só atrasa a mensagem que o usuário precisa
// ler. E consultas ao Redshift não são baratas.
const query = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

const raiz = document.getElementById('raiz');
if (raiz === null) throw new Error('elemento #raiz não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={query}>
      <BrowserRouter>
        <ProvedorAuth>
          <App />
        </ProvedorAuth>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
